import { Component, Input, OnInit } from '@angular/core';
import { ShowPerformance } from '../../models/showperformance.model';

@Component({
    selector: 'app-caro-performance-list',
    templateUrl: './caro-performance-list.component.html',
    styleUrls: ['./caro-performance-list.component.scss'],
    standalone: false
})
export class CaroPerformanceListComponent implements OnInit {

    @Input() public performances: ShowPerformance[] = [];

    @Input() public showError: boolean = false;

    constructor() {
    }

    ngOnInit() {
    }

}
